import { useFormContext } from 'react-hook-form'
import { SliderPx } from './SliderPx'

export function WidgetPersonalization({ config }) {
  const { control } = useFormContext()

  return (
    <div className="flex flex-col gap-10 pb-4">
      {config.headerContent.startsWith('http') && (
        <>
          <section className="flex flex-col gap-4">
            <h2 className="text-sm font-semibold text-gray-800">Header Image</h2>
            <div className="grid grid-cols-2 items-center gap-x-10 gap-y-4">
              <SliderPx control={control} field="styles.headerLogo.height" label="Height" min={1} max={100} />
              <SliderPx control={control} field="styles.headerLogo.width" label="Width" min={1} max={200} />
            </div>
          </section>
          <hr className="border-gray-200" />
        </>
      )}

      <section className="flex flex-col gap-4">
        <h2 className="text-sm font-semibold text-gray-800">Widget Logo</h2>
        <div className="grid grid-cols-2 items-center gap-x-10 gap-y-4">
          <SliderPx control={control} field="styles.logo.width" label="Width" min={5} max={100} />
          <SliderPx control={control} field="styles.logo.height" label="Height" />
          <SliderPx control={control} field="styles.logo.padding" label="Padding" min={0} max={20} />
        </div>
      </section>
      <hr className="border-gray-200" />

      <section className="flex flex-col gap-4">
        <h2 className="text-sm font-semibold text-gray-800">Widget Dimensions</h2>
        <div className="grid grid-cols-2 items-center gap-x-10 gap-y-4">
          <SliderPx control={control} field="styles.widget.width" label="Width" min={5} />
          <SliderPx control={control} field="styles.widget.height" label="Height" min={5} />
          <SliderPx control={control} field="styles.widget.bottom" label="Bottom" max={200} />
          <SliderPx control={control} field="styles.widget.right" label="Right"max={200} />
        </div>
      </section>
      <hr className="border-gray-200" />

      <section className="flex flex-col gap-4">
        <h2 className="text-sm font-semibold text-gray-800">Chat Panel Dimensions</h2>
        <div className="grid grid-cols-2 items-center gap-x-10 gap-y-4">
          <SliderPx control={control} field="styles.panel.width" label="Width" min={250} max={600} />
          <SliderPx control={control} field="styles.panel.height" label="Height" min={400} max={800} />
          <SliderPx control={control} field="styles.panel.bottom" label="Bottom" max={200} />
          <SliderPx control={control} field="styles.panel.right" label="Right" max={200} />
        </div>
      </section>

    </div>
  )
}
